import { OAuthModuleConfig } from 'angular-oauth2-oidc';

// export const authModuleConfig: OAuthModuleConfig = {
//   resourceServer: {
//     allowedUrls: ['https://dev-dp.leetrans.com/api'],
//     sendAccessToken: true,
//   },
// };

// local
// https://localhost:56011/api

// prod
// https://api-dp.leetrans.com/api

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: ['https://api-dp.leetrans.com/api'],
    sendAccessToken: true,
  },
};
